import script from "./HomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=2ca50546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca50546"]])

export default __exports__